import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor() {
  }

  downloadBlobFile(blob: Blob, fileName: string, extension: string = '.pdf'): void {
    const binaryData = [];
    binaryData.push(blob);
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: 'blob'}));
    downloadLink.setAttribute('download', fileName + extension);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
}
